
<template>
  <div class="sys-role header-padding">
    <f-page-header />

    <div class="role-header-box">
      <div class="box-item">
        <f-search-input v-model="query.keyword" @change="fetchData" />
      </div>
      <el-button type="success" icon="el-icon-plus" @click="editor(-1)">新建角色</el-button>
    </div>
    <div class="a-card" v-loading="loading">
      <el-card v-for="role in currentList" :key="role.roleid" class="card-container" shadow="never">
        <div class="flex card-body">
          <div class="card-item">
            <span class="text-bold font-md">{{ role.desc }}</span>
            <div v-if="role.roleid == -1" class="mt-lg text-muted">管理员为内置角色，默认拥有系统全部权限</div>
            <div v-else class="frame-box mt-lg text-muted">
              <!-- <span v-for="(frame, index) in role.frames" :key="index">{{ frame + ' ' + (index + 1 != role.frames.length ? '|' : '') + ' ' }}</span> -->
              <span>{{ role.frames }}</span>
            </div>
          </div>
          <div class="card-item right-area">
            <div class="member-box text-align-center">
              <div class="font-2x number">{{ role.cnt_user }}</div>
              <div class="mt-sm">人 数</div>
            </div>
            <div class="oprea-box">
              <div v-if="role.roleid != -1" class="o-item">
                <el-button type="text" @click="editor(role.roleid)">编辑</el-button>
                <el-button type="text" @click="deleteRole(role)">删除</el-button>
              </div>
              <div v-else class="text-muted">不可编辑删除</div>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <div v-if="currentList.length == 0" class="empty">
      <img class="image huger mt-lg" src="@/assets/empty.png" />
      <div class="font-md mb-hg">暂无数据</div>
    </div>
    <role-editor v-if="showEditor" :show.sync="showEditor" :roleid="roleid" @change="fetchData"></role-editor>
  </div>
</template>

<script>
import { getAllRole, delRoleApi } from '@/api/sys/roleApi'
export default {
  name: 'SysRole',
  components: {
    RoleEditor: () => import('./components/RoleEditor.vue')
  },
  data() {
    return {
      roleList: [],
      loading: false,
      query: {
        keyword: ''
      },
      showEditor: false,
      roleid: -1,
      currentList: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getAllRole(this.query).then(res => {
        if (!res.errno) {
          this.roleList = res.data.list
          this.currentList = Object.assign({}, this.roleList)
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },

    editor(item) {
      this.roleid = item
      this.showEditor = true
    },
    deleteRole(item) {
      this.$confirm(`即将删除角色 <span class="text-danger">${item.desc}</span> ，删除后对应成员将只拥有基本权限，是否继续？`, {
        type: 'error',
        dangerouslyUseHTMLString: true
      }).then(() => {
        delRoleApi({ roleid: item.roleid }).then(res => {
          if (!res.errno) {
            // 操作成功处理
            this.$message.success('删除成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sys-role {
  .role-header-box {
    width: 1180px;
    display: flex;
    margin: 0px auto;
    justify-content: space-between;
  }
  .a-card {
    min-height: 720px;
    width: 1180px;
    margin: 20px auto;

    .card-container {
      margin-top: 10px;
      .card-body {
        padding: 10px 20px;
        height: 145px;
        .card-item {
          flex: 1;
          position: relative;
          .frame-box {
            width: 464px;
            height: 36px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .oprea-box {
            position: absolute;
            right: 0px;
            top: 47px;
          }
        }
        .right-area {
          display: flex;
          justify-content: center;
          align-items: center;
          .member-box {
            text-align: center;
          }
        }
      }
    }
  }
  .empty {
    margin: 40px auto;
    width: 200px;
    text-align: center;
  }
}
</style>